var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-list-item-field',{attrs:{"label":"Pre-screened Outcome"}},[_c('v-icon',{attrs:{"size":"small","color":_vm.color}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }